import React, { useEffect, useState } from "react";
import { firestore } from "../../firebase-config";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import "../../styles/DepartmentDetails.css";
import Modal from "react-modal";

const DepartmentDetails = () => {
  const [departmentData, setDepartmentData] = useState(null);
  const [facultyList, setFacultyList] = useState([]);
  const [nonFacultyList, setNonFacultyList] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  useEffect(() => {
    const fetchDepartmentDetails = async () => {
      try {
        const mechanicalEngineerDoc = doc(firestore, "mechanical_engineer", "general");
        const docSnap = await getDoc(mechanicalEngineerDoc);

        if (docSnap.exists()) {
          setDepartmentData(docSnap.data());

          const facultyCollection = collection(mechanicalEngineerDoc, "faculty");
          const facultySnapshot = await getDocs(facultyCollection);
          const facultyListData = facultySnapshot.docs
            .map((doc) => doc.data())
            .sort((a, b) => (b.experience || 0) - (a.experience || 0));  // SORT BY EXPERIENCE (HIGHEST FIRST)
            setFacultyList(facultyListData);

          const nonFacultyCollection = collection(mechanicalEngineerDoc, "nonFaculty");
          const nonFacultySnapshot = await getDocs(nonFacultyCollection);
          const nonFacultyListData = nonFacultySnapshot.docs
            .map((doc) => doc.data())
            .filter(member => member.name || member.imageUrl || member.interests || member.designation || member.qualification) // Only include members with at least one required field
            .map(member => ({
              name: member.name || "",
              imageUrl: member.imageUrl || "",
              designation: member.designation || "",
              qualification: member.qualification || "",
              interests: member.interests || ""
            }));
          setNonFacultyList(nonFacultyListData);
        } else {
          console.log("No department data found!");
        }
      } catch (error) {
        console.error("Error fetching department data: ", error);
      }
    };

    fetchDepartmentDetails();
  }, []);

  const formatName = (str) => {
    if (!str) return "";
    // First preserve common titles/prefixes
    const titles = ['Prof.', 'Mr.', 'Mrs.', 'Dr.', 'Ms.'];
    let formattedStr = str;
    
    // Check if string starts with any title
    const startsWithTitle = titles.find(title =>
      str.toLowerCase().startsWith(title.toLowerCase())
    );
    
    if (startsWithTitle) {
      // Remove the title temporarily
      formattedStr = formattedStr.substring(startsWithTitle.length).trim();
    }
    
    // Format the remaining name
    formattedStr = formattedStr
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, (char) => char.toUpperCase());
    
    // Add back the title if it existed
    if (startsWithTitle) {
      formattedStr = `${startsWithTitle} ${formattedStr}`;
    }
    
    return formattedStr;
  };


  const openModal = (content) => {
    setModalContent(content);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setModalContent(null);
  };

  const shouldShowReadMore = (interests) => {
    if (!interests) return false;
    return interests.length > 22 || interests.split(' ').length > 3;
  };

  return (
    <div className="department-details">
      <h1 className="centered-title">DEPARTMENT OF MECHANICAL ENGINEERING</h1>

      <div className="department-image">
        {departmentData?.departmentPhotoUrl && (
          <img src={departmentData.departmentPhotoUrl} alt="Department" />
        )}
      </div>

      
{departmentData && (
  <div className="department-info">
    <div className="left-side">
      <div className="box">
        <h2>VISSION</h2>
        <p>{departmentData.vision}</p>
      </div>

      <div className="box">
        <h2>MISSION</h2>
        <ul className="mission-list">
          {departmentData.mission
            .split('.')
            .filter(sentence => sentence.trim() !== '')
            .map((sentence, index) => (
              <li key={index}>{sentence.trim()}.</li>
          ))}
        </ul>
      </div>
    </div>

    <div className="about-department box">
      <h2>ABOUT</h2>
      <p>{departmentData.about}</p>
    </div>
  </div>
)}

      <div className="yellow-line"></div>

      <h2>HOD MESSAGE</h2>


      <div className="hodtalk full-width">
        {departmentData?.hodDetails?.talk && <p>{departmentData.hodDetails.talk}</p>}
      </div>

      <div className="yellow-line"></div>
      <div className="faculty-section">
        <h2>FACULTY</h2>
        <div className="faculty-grid">
          {departmentData?.hodDetails && (
            <div className="faculty-grid-item">
              <div className="faculty-image">
                {departmentData.hodDetails.imageUrl && (
                  <img src={departmentData.hodDetails.imageUrl} alt={departmentData.hodDetails.name} />
                )}
                {departmentData.hodDetails.name && (
                  <h3>{formatName(departmentData.hodDetails.name)}</h3>
                )}
              </div>
              <div className="faculty-details">
                {departmentData.hodDetails.designation && (
                  <p><strong>Designation:</strong> {departmentData.hodDetails.designation}</p>
                )}
                {departmentData.hodDetails.qualification && (
                  <p><strong>Qualification:</strong> {departmentData.hodDetails.qualification}</p>
                )}
                {departmentData.hodDetails.interests && (
                  <button
                    className="read-more-button"
                    onClick={() =>
                      openModal({ ...departmentData.hodDetails })
                    }
                  >
                    Read More
                  </button>
                )}
              </div>
            </div>
          )}

          {facultyList
            .filter(faculty => faculty.name?.toLowerCase() !== departmentData.hodDetails.name?.toLowerCase())
            .map((faculty, index) => (
              <div key={index} className="faculty-grid-item">
                <div className="faculty-image">
                  {faculty.imageUrl && <img src={faculty.imageUrl} alt={faculty.name} />}
                  {faculty.name && <h3>{formatName(faculty.name)}</h3>}
                </div>
                <div className="faculty-details">
                  {faculty.designation && <p><strong>Designation:</strong> {faculty.designation}</p>}
                  {faculty.qualification && <p><strong>Qualification:</strong> {faculty.qualification}</p>}
                  {faculty.interests && (
                    <button
                      className="read-more-button"
                      onClick={() => openModal({ ...faculty })}
                    >
                      Read More
                    </button>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>     
       <div className="yellow-line"></div>

      <div className="non-faculty-section">
  <h2>NON-FACULTY</h2>
  <div className="non-faculty-grid">
    {nonFacultyList.map((nonFaculty, index) => (
      <div key={index} className="non-faculty-grid-item">
        <div className="non-faculty-image">
          {nonFaculty.imageUrl && (
            <img src={nonFaculty.imageUrl} alt={nonFaculty.name || 'Non-faculty member'} />
          )}
          {nonFaculty.name && <h3>{formatName(nonFaculty.name)}</h3>}
        </div>
        <div className="non-faculty-details">
          {nonFaculty.designation && <p><strong>Designation:</strong> {nonFaculty.designation}</p>}
          {nonFaculty.qualification && <p><strong>Qualification:</strong> {nonFaculty.qualification}</p>}
          {(nonFaculty.interests || nonFaculty.designation || nonFaculty.qualification) && (
            <button
              className="read-more-button"
              onClick={() =>
                openModal({
                  imageUrl: nonFaculty.imageUrl,
                  interests: nonFaculty.interests,
                  name: nonFaculty.name,
                  designation: nonFaculty.designation,
                  qualification: nonFaculty.qualification,
                })
              }
            >
              Read More
            </button>
          )}
        </div>
      </div>
    ))}
  </div>
</div>

    

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Member Details"
        className="modal-content"
        overlayClassName="ReactModal__Overlay"
      >
        {modalContent && (
          <div className="modal-inner">
            <div className="modal-content-wrapper">
              {modalContent.imageUrl && (
                <img
                  src={modalContent.imageUrl}
                  alt="Member"
                  className="modal-image"
                />
              )}
              <h3 className="modal-member-name">{formatName(modalContent.name)}</h3>
              <div className="details-grid">
                {modalContent.designation && <>
                  <span className="detail-label">Designation:</span>
                  <span className="detail-content">{modalContent.designation}</span>
                </>}
                {modalContent.qualification && <>
                  <span className="detail-label">Qualification:</span>
                  <span className="detail-content">{modalContent.qualification}</span>
                </>}
                <span className="detail-label">Interests:</span>
                <span className="detail-content">{modalContent.interests}</span>
              </div>
              <button
                onClick={closeModal}
                className="modal-close-button"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default DepartmentDetails;